import { render, staticRenderFns } from "./BundleSetStepGeneralInfo.vue?vue&type=template&id=2e3ae819&scoped=true&"
import script from "./BundleSetStepGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./BundleSetStepGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./BundleSetStepGeneralInfo.vue?vue&type=style&index=0&id=2e3ae819&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3ae819",
  null
  
)

export default component.exports